import { Box, Paper } from '@material-ui/core';
import React from 'react';

import { ContrastedCard } from '@/components/shared/components/ContrastedCard';
import { IconHeader } from '@/components/shared/components/IconHeader';

interface IconHeaderCard {
  labelTid?: string;
  surLabelTid?: string;
  subLabelTid?: string;
  labelComponent?: string;
  iconName?: string;
  endIcon?: string;
  color: 'primary' | 'secondary' | 'minor';
  variant?: 'small' | 'medium' | 'large';
  subLabelVariant?: 'caption' | 'overline';
  onClick?: () => void;
  buttonIconName?: string;
  buttonStyle?: React.CSSProperties;
  children?: React.ReactNode;
  style?: React.CSSProperties;
  paperProps?: React.ComponentProps<typeof Paper>;
  boxProps?: React.ComponentProps<typeof Box>;
  disabled?: boolean;
  linkTo?: string;
  copyToClipboard?: {
    value: string;
    textId: string;
  };
  actionsOptionsArray?: {
    display: string | React.ReactElement;
    onClick: () => void;
    iconName?: string;
  }[];
  forceSingleLine?: boolean;
}

export const IconHeaderCard = ({
  labelTid,
  iconName,
  endIcon,
  color,
  surLabelTid,
  subLabelTid,
  labelComponent,
  onClick,
  children,
  paperProps,
  boxProps,
  disabled,
  variant,
  subLabelVariant,
  copyToClipboard,
  actionsOptionsArray,
  linkTo,
  forceSingleLine,
}: IconHeaderCard) => {
  return (
    <ContrastedCard
      onClick={onClick}
      linkTo={linkTo}
      paperProps={paperProps}
      boxProps={boxProps}
      endIcon={endIcon}
      disabled={disabled}
    >
      <Box display={'flex'} justifyContent={'space-between'} overflow={'hidden'} minWidth={0} flexGrow={1}>
        <IconHeader
          color={color}
          iconName={iconName}
          surLabelTid={surLabelTid}
          labelTid={labelTid}
          subLabelTid={subLabelTid}
          labelComponent={labelComponent}
          variant={variant}
          subLabelVariant={subLabelVariant}
          copyToClipboard={copyToClipboard}
          actionsOptionsArray={actionsOptionsArray}
          forceSingleLine={forceSingleLine}
        />
      </Box>
      <Box>{children}</Box>
    </ContrastedCard>
  );
};
